"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugLayer = void 0;
const tslib_1 = require("tslib");
const phaser_1 = tslib_1.__importDefault(require("phaser"));
class DebugLayer extends phaser_1.default.GameObjects.Container {
    constructor(scene, x = 0, y = 0, getDevicePixelRatio, config) {
        super(scene, x, y);
        const { width, height } = scene.cameras.main;
        this.bg = new phaser_1.default.GameObjects.Graphics(scene);
        this.add(this.bg);
        const vw = Math.round(width * 0.01);
        const fontSize = Math.round(3 * vw);
        const fontStyle = {
            fontSize: `${fontSize}px`,
            fontFamily: 'sans-serif',
            color: '#aaaaaa',
        };
        const padding = Math.round(vw);
        const lineSize = Math.round(fontSize * 1.2);
        let textLine = 0;
        if (config.showFps) {
            this.fpsLabel = new phaser_1.default.GameObjects.Text(scene, padding, padding + lineSize * (textLine++), 'FPS: 120', fontStyle);
            this.add(this.fpsLabel);
        }
        if (config.showResolution) {
            this.screenSizeLabel = new phaser_1.default.GameObjects.Text(scene, padding, padding + lineSize * (textLine++), `R: ${width}×${height}`, fontStyle);
            this.add(this.screenSizeLabel);
        }
        if (config.showDPR) {
            this.dprLabel = new phaser_1.default.GameObjects.Text(scene, padding, padding + lineSize * (textLine++), `DPR: ${getDevicePixelRatio()}`, fontStyle);
            this.add(this.dprLabel);
        }
        if (config.showTextureCacheSize) {
            this.textureCacheSizeLabel = new phaser_1.default.GameObjects.Text(scene, padding, padding + lineSize * (textLine++), 'TCS: 0', fontStyle);
            this.add(this.textureCacheSizeLabel);
        }
        const rect = this.getBounds();
        rect.setPosition(0, 0);
        rect.setSize(rect.width + padding * 2, rect.height + padding * 2);
        this.bg.fillStyle(0x000000, 0.5);
        this.bg.fillRectShape(rect);
        this.fps = 0;
    }
    set fps(value) {
        if (!this.fpsLabel) {
            return;
        }
        this.fpsLabel.text = `FPS: ${value}`;
    }
    updateTextureCacheSize() {
        if (!this.textureCacheSizeLabel) {
            return;
        }
        const textureCacheSize = this.scene.getTexturesCacheSize() / 1024 / 1024;
        this.textureCacheSizeLabel.text = `TCS: ${textureCacheSize.toFixed(2)}M`;
    }
    update(_time, delta) {
        this.fps = Math.floor(1000 / delta);
        this.updateTextureCacheSize();
        super.update();
    }
}
exports.DebugLayer = DebugLayer;
